// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SfyP","delete":"styles_delete__3Cct-","update":"styles_update__2vsVJ","add":"styles_add__3GAYT"};